export const m6DmVariants = [
  {
    type: 'Classic Standard',
    price: 'Rp298.000.000',
    numericPrice: 298000000,
  },
  {
    type: 'Classic Dynamic',
    price: 'Rp318.000.000',
    numericPrice: 318000000,
  },
  {
    type: 'Cross Advanced',
    price: 'Rp360.000.000',
    numericPrice: 360000000,
  },
  {
    type: 'Cross Superior',
    price: 'Rp380.000.000',
    numericPrice: 380000000,
  },
  {
    type: 'Cross Superior Captain',
    price: 'Rp390.000.000',
    numericPrice: 390000000,
  },
];

export const m6DmStartingPrice = m6DmVariants[0].price;
export const m6DmHighestPrice = m6DmVariants[m6DmVariants.length - 1].price;
export const m6DmPriceRange = `${m6DmStartingPrice} - ${m6DmHighestPrice}`;

